import { render, staticRenderFns } from "./MissingDocumentCard.vue?vue&type=template&id=277e2cfb&scoped=true"
import script from "./MissingDocumentCard.vue?vue&type=script&lang=ts"
export * from "./MissingDocumentCard.vue?vue&type=script&lang=ts"
import style0 from "./MissingDocumentCard.vue?vue&type=style&index=0&id=277e2cfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e2cfb",
  null
  
)

export default component.exports